import React, { useEffect, useState } from 'react';
import { Row, Button, Input, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, CustomInput } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { postAPI_PublishGPT, API_Ingetration, gAPI_Users_By_Id } from '../../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../../components/common/react-notifications';

function PublishGPT({ propertyId, locale, email, isSuperAdmin }) {
    const [isEnabled, setIsEnabled] = useState(false);
    const [version, setVersion] = useState("3");
    const [isButtonShow, setIsButtonShow] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [checkboxes, setCheckboxes] = useState({
        pii: false,
        confidentiality: false,
        harmfulfree: false,
    });
    const [isFormValid, setIsFormValid] = useState(false);
    useEffect(() => {
        let body = {
            channels: ['WebsiteDirectLine']
        };
        AxiosAPI({
            method: 'post',
            url: `${API_Ingetration}?group_id=${getGroupID()}`,
            data: body
        }).then((res) => {
            const webIntegrationData = res.data.filter(
                (k) => k.channel === 'WebsiteDirectLine' && k.disabled === false && k.properties.includes(propertyId)
            );
            webIntegrationData.map((k) => {
                var botsetting = k.botSettings;
                if (botsetting.features !== null &&
                    botsetting.features.generativeChatGPT === true ||
                    botsetting.features.generativeGPT3 === true) {
                    setIsEnabled(true);
                }
            })
        });
        AxiosAPI({
            method: 'get',
            url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
        }).then((res) => {
            var admin = false;
            var user = false;
            var agent = false;
            var sa = false;
            res.data.roles.forEach((r) => {
                if (r === 'User') { user = true; }
                if (r === 'Admin') { admin = true; }
                if (r === 'Agent') { agent = true; }
                if (r === 'SuperAdmin' || isSuperAdmin) { sa = true; }
            });
            if (sa === false && admin === false && user === false && agent === true) {
                setIsButtonShow(false);
            }
        })
    }, [propertyId]);

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setCheckboxes((prev) => {
            const updatedCheckboxes = { ...prev, [name]: checked };
            setIsFormValid(updatedCheckboxes.pii && updatedCheckboxes.confidentiality && updatedCheckboxes.harmfulfree);
            return updatedCheckboxes;
        });
    };

    const handlePublish = () => {
        var body = {
            GroupId: getGroupID(),
            PropertyId: propertyId,
            Language: locale === 'en' ? 'en-US' : locale,
            email: email,
            version: version,
            Creator: 'dashboard',
        };
        AxiosAPI({
            method: 'post',
            url: `${postAPI_PublishGPT}`,
            data: body,
        }).then(() =>
            NotificationManager.success(
                '',
                'We have received your request. Publish will take few minutes.',
                3000,
                null,
                null,
                'success'
            )
        );
        toggleModal();
    };


    return isEnabled === true && isButtonShow && (
        <>
            <Row className="">
                {/* <Colxx xxs="6" className="mb-2">
                    <Input
                        type="select"
                        name="version"
                        value={version}
                        onChange={(e) => setVersion(e.target.value)}
                        style={{ height: "2.7rem", borderRadius: "6px" }}
                    >
                        <option value="2">Version 2.0 (retired)</option>
                        <option value="3">Version 3.0 (latest)</option>
                    </Input>
                </Colxx> */}
                <Colxx xxs="6" className="mb-2">
                    {/* {propertyId === '1589c711-19a4-4ada-894b-afe7015fadd6' && ( */}
                    <Button
                        color="primary"
                        outline
                        size="xs"
                        // onClick={() => {
                        //     handlePublish();
                        // }}
                        onClick={toggleModal}
                    // style={{ width: '100%', borderRadius: '6px' }}
                    >
                        Publish GPT
                    </Button>
                </Colxx>
            </Row>
            {/* Modal for publish GPT  */}
            <Modal isOpen={isModalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Confirm to Publish GPT</ModalHeader>

                <ModalBody>
                    <h6 className='mb-2'>I acknowledge that:</h6>
                    <FormGroup>

                        <CustomInput
                            type="checkbox"
                            id="pii"
                            name="pii"
                            label="Data does not contain any personally identifiable information (PII)."
                            checked={checkboxes.pii}
                            onChange={handleCheckboxChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <CustomInput
                            type="checkbox"
                            id="confidentiality"
                            name="confidentiality"
                            label="Data does not contain any confidential, restricted, or commercially sensitive information."
                            checked={checkboxes.confidentiality}
                            onChange={handleCheckboxChange}
                        />
                    </FormGroup>
                    <FormGroup>
                        <CustomInput
                            type="checkbox"
                            id="harmfulfree"
                            name="harmfulfree"
                            label="The data is free from harmful, abusive, or biased content."
                            checked={checkboxes.harmfulfree}
                            onChange={handleCheckboxChange}
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="primary"
                        disabled={!isFormValid}
                        onClick={handlePublish}
                    >
                        Publish GPT
                    </Button>
                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
}
const mapStateToProps = ({ settings, usersListApp }) => {
    const { propertyId, locale, email } = settings;
    const { isSuperAdmin } = usersListApp;
    return {
        propertyId,
        locale,
        email,
        isSuperAdmin
    };
};

export default injectIntl(connect(mapStateToProps)(PublishGPT));
